import { createReducer } from '@reduxjs/toolkit';

import postRoles from '../../thunks/roles/postRoles';
import patchRoles from '../../thunks/roles/patchRoles';

const initialState = {
  loading: false,
  error: null,
  createId: undefined
};

const postRolesReducer = createReducer(initialState, {
  [postRoles.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
    createId: undefined
  }),
  [postRoles.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    createId: payload
  }),
  [postRoles.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    createId: undefined
  }),
  [patchRoles.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
    createId: undefined
  }),
  [patchRoles.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    createId: payload,
  }),
  [patchRoles.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    createId: undefined
  }),
});

export default postRolesReducer;
